class ShippingTime extends HTMLElement {
  constructor() {
    super();
    this.deliveryTimeDate = '';
    this.deliveryTimeTime = '';
    this.selectedDeliveryTimeTime = '';

    this.LocaleDate = '';
    this.LocaleTime = ''; 
    this.LocaleMonth = '';
    this.AmOrPm = '';
    this.ifToday = false;
    
    this.deliveryMethod = document.getElementById('delivery_selector');
    this.dateInput = document.getElementById('date_input');
    this.dateSelector = document.getElementById('date_selector');
    this.dateSelector2 = document.getElementById('date_selector_2');
    this.cardSelector = document.getElementById('card_selector');
    this.giftMessageText = document.getElementById('gift_message_text');
    this.giftArea = this.querySelector('.delivery');
    
    this.DeliveryTimeH = document.getElementById('DeliveryTimeH');
    this.GiftMessageH = document.getElementById('GiftMessageH');

    
    
    this.deliveryMethod.addEventListener('change', this.onChangeDeliveryMethodHandle.bind(this));
    this.cardSelector.addEventListener('change', this.onChangeCardSelectorHandle.bind(this));
    this.giftMessageText.addEventListener('change', this.onChangeGiftMessageHandle.bind(this));
    this.dateInput.addEventListener('change', this.onChangeGiftMessageHandle.bind(this));
    this.dateSelector.addEventListener('change', this.onChangeGiftMessageHandle.bind(this));
    this.dateSelector2.addEventListener('change', this.onChangeGiftMessageHandle.bind(this));
  }

  formatDate(date) {
  // 统一用数字再补零，避免 NaN
  const m = date.getMonth() + 1; // 1-12
  const d = date.getDate();      // 1-31
  const month = m > 9 ? `${m}` : `0${m}`;
  const day   = d > 9 ? `${d}` : `0${d}`;
  const year  = date.getFullYear();
  return `${year}-${month}-${day}`;
  }

  updateCurrentTime(){
  const now = new Date();
  this.LocaleDate = this.formatDate(now);
  let hours = now.getHours();
  this.AmOrPm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  this.LocaleTime = hours === 0 ? 12 : hours; // 12点还原为12
  }

  getSelectedText(target) {
    return target.options[target.selectedIndex].text;
  }
  
  onChangeGiftMessageHandle(evt){
    if (evt.target === this.giftMessageText) {
      if (this.GiftMessageH) {
        this.GiftMessageH.value = evt.target.value;
        var maxLength = evt.target.getAttribute('maxlength');
        var currentLength = evt.target.value.length;
        var remaining = maxLength - currentLength;
        document.getElementById('remainingChars').innerText = remaining;
      }
    }else if (evt.target === this.dateInput) {
      if (this.DeliveryTimeH) {
        this.deliveryTimeDate = evt.target.value;
        // alert(new Date(this.deliveryTimeDate));
        this.updateDeliveryTime();
      }
    }else if (evt.target === this.dateSelector || evt.target === this.dateSelector2) {
      if (this.DeliveryTimeH) {
        if (evt.target.value === '-1') {
          this.deliveryTimeTime = '';
          this.selectedDeliveryTimeTime = ''
        }else{
          this.selectedDeliveryTimeTime = evt.target.value;
          this.deliveryTimeTime = this.getSelectedText(evt.target);
        }
        this.updateDeliveryTime();
      }
    }
  }

  getDayOrMonth(date,dm){
  const [y,m,d] = date.split("-");
  if (dm === 'd') return d;
  if (dm === 'y') return y;
  return m;
  }

  updateDeliveryTime(){
  if (this.deliveryTimeDate !== '') {
    this.updateCurrentTime();

    // // 用 Date 对象比较，避免字符串比较误判
    // const today = new Date(this.LocaleDate);
    // const selected = new Date(this.deliveryTimeDate);

    // if (today > selected) {
    //   alert('The date is unavailable. Please select another one.');
    //   this.dateInput.value = '';
    //   return;
    // }

    // 限制 14 天内
    // const timeDiff = Math.abs(selected - today);
    // const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    // if (daysDiff > 14) {
    //   alert("Sorry,the delivery date must be within two weeks.");
    //   this.dateInput.value = '';
    //   return;
    // }

    if (this.deliveryTimeDate === '' || this.deliveryTimeTime === '') {
      this.DeliveryTimeH.value = '';
      return;
    }

    // 当天的时间段有效性（pm 且当前小时 > 所选起始小时）
    const selectedHour = Number(this.selectedDeliveryTimeTime); // "2" -> 2
    if (this.AmOrPm === 'pm' && this.LocaleDate === this.deliveryTimeDate && this.LocaleTime > selectedHour) {
      alert('The current time slot is unavailable. Please select another one.');
      return;
    }

    this.DeliveryTimeH.value =
      `${this.deliveryTimeDate} ${this.deliveryTimeTime}(${this.getSelectedText(this.deliveryMethod)})`;
  }
  }

  onChangeDeliveryMethodHandle(evt){
    if (evt.target.value === 'self') {
      this.dateSelector2.classList.remove('date-input_sel_none');
      this.dateSelector.classList.add('date-input_sel_none');

      if (this.dateSelector2.value === '-1') {
        this.deliveryTimeTime = '';
        this.selectedDeliveryTimeTime = '';
      }else{
        this.selectedDeliveryTimeTime = this.dateSelector2.value;
        this.deliveryTimeTime = this.getSelectedText(this.dateSelector2);
      }
    }else if (evt.target.value === 'merchant') {
      // alert('Sorry,delivery is temporarily unavailable');
      // evt.target.value = 'self';
      // return;
      this.dateSelector2.classList.add('date-input_sel_none');
      this.dateSelector.classList.remove('date-input_sel_none');
      
      if (this.dateSelector.value === '-1') {
        this.deliveryTimeTime = '';
        this.selectedDeliveryTimeTime = '';
      }else{
        this.selectedDeliveryTimeTime = this.dateSelector.value;
        this.deliveryTimeTime = this.getSelectedText(this.dateSelector);
      }
    }
    this.updateDeliveryTime();
  }
  
  onChangeCardSelectorHandle(evt){
    if (evt.target.value === 'false') {
      this.giftArea.classList.remove('date-input_sel_none');
      this.GiftMessageH.value = this.giftMessageText.value;
    }else if (evt.target.value === 'true') {
      this.giftArea.classList.add('date-input_sel_none');
      this.GiftMessageH.value = '';
    }
  }  

  
}

customElements.define('shipping-time', ShippingTime);


